import React, { memo } from 'react';
import { bool, func, string } from 'prop-types';
import DatePicker from 'react-datepicker';
import { ErrorInput as StorybookErrorInput } from '@sunbeltrentals/sbr-global-components';
import './customDatePicker.scss';

const CustomDatePicker = props => {
    const {
        datePickerClassName,
        label,
        name,
        dateFormat,
        required,
        onChange,
        isVisible,
        onFocus,
        errorMsg,
        validateDate,
        value,
        disclaimer,
        dataTestId,
        wrapperClassName,
        id
    } = props;

    return (
        <div className={`cmp-Field__field__root ${wrapperClassName}`} data-testid='date-picker'>
            <label className={`cmp-Field__field__label ${errorMsg ? 'date-picker__error_label' : ''}     `}>
                {label}
                {required && <span className="requiredSymbol" />}
            </label>
            <DatePicker
                className={`cmp-Field__field__input ${datePickerClassName} ${
                    errorMsg ? 'error_input__border ' : ''
                }     `}
                name={name}
                popperClassName={!isVisible ? 'date-picker__hide' : ''}
                selected={value}
                onChange={date => onChange(date)}
                dateFormat={dateFormat}
                onChangeRaw={validateDate}
                onFocus={onFocus}
                data-testid={dataTestId}
                id={id}
            />

            <StorybookErrorInput errorMsg={errorMsg} />

            {disclaimer && (
                <small className="date-picker__disclaimer" tabIndex="0">
                    {disclaimer}
                </small>
            )}
        </div>
    );
};

CustomDatePicker.propTypes = {
    className: string,
    label: string,
    name: string,
    dateFormat: string,
    required: bool,
    onChange: func,
    isVisible: bool,
    onFocus: func,
    errorMsg: string,
    validateDate: func,
    disclaimer: string,
    dataTestId: string,
    wrapperClassName: string,
    id: string
};

CustomDatePicker.defaultProps = {
    className: '',
    label: '',
    name: '',
    dateFormat: '',
    required: false,
    onChange: () => {},
    isVisible: true,
    onFocus: () => {},
    errorMsg: '',
    validateDate: () => {},
    disclaimer: '',
    dataTestId: '',
    wrapperClassName: '',
    id: ''
};

export default memo(CustomDatePicker);
